import { render, staticRenderFns } from "./UpdateAppMassage.vue?vue&type=template&id=028bddda&scoped=true&"
import script from "./UpdateAppMassage.vue?vue&type=script&lang=js&"
export * from "./UpdateAppMassage.vue?vue&type=script&lang=js&"
import style0 from "./UpdateAppMassage.vue?vue&type=style&index=0&id=028bddda&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028bddda",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VSnackbar})
